<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('contact.title'),
            subtitle: {
                first_text: $t('contact.label'),
                first_href: '/',
                second_text: $t('contact.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <h2> {{ $t('contact.stay_on_contact') }}</h2>
                    <p>{{ $t('contact.p') }}</p>
                    <div class="contact_info">
                        <ContactInfo/>
                    </div>
                    <h2>{{ $t('contact.follow_us_on') }}</h2>
                    <div class="social_icons">
                        <img src="@/assets/images/social/youtube_light.png"/>
                        <img src="@/assets/images/social/instagram_light.png"/>
                        <img src="@/assets/images/social/x_light.png"/>

                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <ContactForm/>
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import ContactInfo from '@/components/ContactInfo.vue';
import ContactForm from '@/components/Contact/ContactForm.vue';

export default {
    components: {
        AppFooter, AppNavbar, PagesHero,ContactInfo,ContactForm
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}


h2 {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 30px;
}

p {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 40px;
}


.container {
    padding-bottom: 80px;
}

.contact_info {
    margin-bottom: 40px;
}

.social_icons {
    display: flex;
    flex-direction: row;
    gap: 10px; /* Adjust the space as needed */
}

.social_icons img {
    width: 38px;
    height: auto;
    cursor: pointer;
}


</style>